/**
 * Setup-form pre-fill helpers (#33822). The Sweep Account setup form is seeded from the
 * agency record we already hold (`getSweepAccountPrefill`), and fields we have a value for
 * are locked so agents can't accidentally change them. Email and Phone stay editable even
 * when pre-filled; Address line 2 is never sourced, so it's always editable.
 */

// Fields that lock once we have a value. Deliberately excludes email/phone (always editable)
// and line2 (no stored source).
const LOCKABLE_FIELDS = ['name', 'line1', 'city', 'state', 'zip'];

/** Seed Formik initial values from the prefill (missing fields → empty, editable). */
export const buildPrefillInitialValues = (prefill) => ({
  name: prefill?.name ?? '',
  email: prefill?.email ?? '',
  phone: prefill?.phone ?? '',
  line1: prefill?.line1 ?? '',
  line2: '',
  city: prefill?.city ?? '',
  state: prefill?.state ?? '',
  zip: prefill?.zip ?? '',
  paymentMethodType: 'card'
});

/** True when a field should be read-only because we already hold its value. */
export const isFieldLocked = (field, prefill) => LOCKABLE_FIELDS.includes(field) && Boolean(prefill?.[field]);
